import React from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

const ServerDetailsSnackbars = ({
    connectSuccess,
    connectFail,
    copySuccess,
    purchaseSnackbar,
    onCloseMain,
    onClosePurchase,
}) => (
    <>
        <Snackbar open={connectSuccess} autoHideDuration={3000} onClose={onCloseMain} anchorOrigin={{ vertical: "bottom", horizontal: "center" }}>
            <Alert onClose={onCloseMain} severity="success" sx={{ width: "100%" }}>
                Аккаунты успешно связаны
            </Alert>
        </Snackbar>

        <Snackbar open={connectFail} autoHideDuration={3000} onClose={onCloseMain} anchorOrigin={{ vertical: "bottom", horizontal: "center" }}>
            <Alert onClose={onCloseMain} severity="error" sx={{ width: "100%" }}>
                Вы отменили привязку аккаунта
            </Alert>
        </Snackbar>

        <Snackbar open={copySuccess} autoHideDuration={3000} onClose={onCloseMain} anchorOrigin={{ vertical: "bottom", horizontal: "center" }}>
            <Alert onClose={onCloseMain} severity="success" sx={{ width: "100%" }}>
                IP и порт скопированы в буфер обмена!
            </Alert>
        </Snackbar>

        <Snackbar open={purchaseSnackbar.open} autoHideDuration={6000} onClose={onClosePurchase} anchorOrigin={{ vertical: "bottom", horizontal: "center" }}>
            <Alert onClose={onClosePurchase} severity={purchaseSnackbar.severity} sx={{ width: "100%" }}>
                {purchaseSnackbar.message}
            </Alert>
        </Snackbar>
    </>
);

export default ServerDetailsSnackbars;
